<template>
  <div id="app">
    <mMenu/>
  </div>
</template>

<script>
import mMenu from './components/home/menu.vue'
export default {
  name: 'App',
  components: {
   mMenu
  }
}
</script>

<style lang="scss">
@import './assets/css/css.css';
.mColor{
	color: #004F9D;
}
body{
  margin: 0;
  padding: 0;
}
body > .el-container {
  margin-bottom: 40px;
}
body > .poperclass{
	min-width: 80px!important;
	.poptxt:hover{
		color: #004F9D;
	}
}
 
</style>
